module.exports = __webpack_public_path__ + "static/media/bq_dsv.19e8a682.png";